import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Head from '../../components/head';
import ItemBox from '../../components/itens/item';


function RenunciaScreen() {
    return (
        <Fragment>
            <Head titulo="Renúncia de Receitas - Portal da Transparência da Prefeitura de Macuco" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Row xs={1} lg={2}>
                    <Col>
                        <ItemBox
                            titulo={"Renúncias por ano"}
                            descricao={<Fragment>Veja aqui as renúcias de receita listadas por ano.<br /><br /></Fragment>}
                            awesome={"faCalendar"}
                            link={"../transparencia/contas/renuncias"}
                        />
                    </Col>
                    <Col>
                        <ItemBox
                            titulo={"Renúncias detalhadas"}
                            descricao={<Fragment>Veja aqui a listagem de Renúncias de Receitas com informações pormenorizadas.<br /><br /></Fragment>}
                            awesome={"faMagnifyingGlassDollar"}
                            link={"../transparencia/renunciareceita"}
                        />
                    </Col>
                    <Col>
                        <ItemBox
                            titulo={"Projetos Culturais"}
                            descricao={<Fragment>Veja aqui a listagem de projetos culturais e esportivos patrocinados ou que receberam doações em nosso município.<br /><br /></Fragment>}
                            awesome={"faMasksTheater"}
                            link={"../transparencia/projetocultural"}
                        />
                    </Col>
                </Row>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default RenunciaScreen;